import Swiper from 'swiper';
import './register'
import './tabs-wrapper'
import './list-accordion'
import './slider-content-left'
import './lightbox'
import './cf7-mailsent'
import './cf7-custom'
import './single-product--auctions.js'

var mySwiper = new Swiper ('.swiper-container--default', {
  direction: 'horizontal',
  loop: true,
  setWrapperSize: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});


if ( document.querySelector('.swiper-container--before-after') ) {
  new Swiper ('.swiper-container--before-after', {
    direction: 'horizontal',
    loop: true,
    setWrapperSize: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      slideChangeTransitionEnd: function(swiper) {
        var currentIndexEl = this.$el[0].parentNode.querySelector('.title-index .gallery-current');
        console.log(currentIndexEl);
        if (currentIndexEl) {
          currentIndexEl.textContent = this.realIndex + 1;
        }
      }
    }
  });
}

if (document.querySelector('.item-share')) {
 
  document.querySelector('.item-share').addEventListener('click', event => {

    event.preventDefault();
    event.currentTarget.classList.toggle('is-active');
    document.querySelector('.share-wrapper').classList.toggle('is-active');
    
  });

}
